<template>
  <b-card>

    <b-row>

      <!-- User Info: Left col -->
      <b-col
        cols="21"
        xl="4"
        class="d-flex justify-content-between flex-column"
      >
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <b-avatar
            :src="sectorData.avatar"
            :text="avatarText(sectorData.name)"
            variant="light-primary"
            size="104px"
            rounded
          />
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <p class="text-muted mb-0">#{{sectorData.number}}</p>
              <h4 class="mb-1">
                {{ sectorData.name }}
              </h4>
            </div>
          </div>
        </div>
      </b-col>

      <!-- Right Col: Table -->
      <b-col
        cols="12"
        xl="4"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr class="cursor-pointer" @click="$emit('open-tab', 'station')" title="Перейти к списку">
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold text-primary">Станций/Перегонов</span>
            </th>
            <td class="pb-50">
              {{ sectorData.station_count }}
            </td>
          </tr>
          <tr class="cursor-pointer" @click="$emit('open-tab', 'platform')" title="Перейти к списку">
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold text-primary">Платформ</span>
            </th>
            <td class="pb-50">
              {{ sectorData.platform_count }}
            </td>
          </tr>
          <tr class="cursor-pointer" @click="$emit('open-tab', 'pillar')" title="Перейти к списку">
            <th>
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold text-primary">Опор</span>
            </th>
            <td class="pb-50">
              {{ sectorData.opora_count }}
            </td>
          </tr>
          <tr class="cursor-pointer" @click="$emit('open-tab', 'bridge')" title="Перейти к списку">
            <th>
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold text-primary">Мостов</span>
            </th>
            <td class="pb-50">
              {{ sectorData.most_bridge_count }}
            </td>
          </tr>
          <tr class="cursor-pointer" @click="$emit('open-tab', 'shed')" title="Перейти к списку">
            <th>
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold text-primary">Навесов</span>
            </th>
            <td class="pb-50">
              {{ sectorData.naves_count }}
            </td>
          </tr>
          <tr class="cursor-pointer" @click="$emit('open-tab', 'fencing')" title="Перейти к списку">
            <th>
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold text-primary">Торцевых ограждений</span>
            </th>
            <td class="pb-50">
              {{ sectorData.torcevoe_ograzdenie_count }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BCard, BButton, BRow, BCol, BAvatar,
  },
  props: {
    sectorData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      avatarText,
    }
  },
}
</script>

<style>

</style>
